







































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import { TypeHeading, BaseIcon, TypeDisplay, TypeBody } from '@bambeehr/pollen';

export default defineComponent({
  name: 'BaseFAQ',
  components: {
    TypeHeading,
    TypeDisplay,
    BaseIcon,
    TypeBody,
  },
  props: {
    question: {
      type: String as PropType<string>,
      required: false,
      default: '',
    },
    answer: {
      type: String as PropType<string>,
      required: false,
      default: '',
    },
  },
  setup() {
    const isIconClicked = ref(false);
    const handleClick = () => {
      isIconClicked.value = !isIconClicked.value;
    };

    return {
      isIconClicked,
      handleClick,
    };
  },
});
